<template>
    <tr class="lecture">
        <!-- Godzina wykładu -->
        <td
            :class="`lecture__hour ${
                Object.hasOwn(lecture, 'customLine')
                    ? 'lecture__hour--normal-weight'
                    : ''
            }`"
        >
            <div
                v-if="Object.hasOwn(lecture, 'hour')"
                class="lecture__hour-div"
            >
                <template v-if="typeof lecture.hour === 'string'">
                    <span>{{ lecture.hour }}</span>
                </template>
                <template v-else>
                    <span>{{ lecture.hour.value }}</span>
                </template>
            </div>
        </td>
        <td v-if="Object.hasOwn(lecture, 'title')">
            <div class="lecture__title-wrapper">
                <!-- Tytuł wykładu -->
                <div class="lecture__title">
                    <template v-if="typeof lecture.title === 'string'">
                        {{ lecture.title }}
                    </template>
                    <template v-else-if="Array.isArray(lecture.title)">
                        <span v-for="title in lecture.title">
                            <template v-if="typeof title === 'string'">
                                {{ title }}
                            </template>
                            <template v-else>
                                {{ title.value }}
                            </template>
                        </span>
                    </template>
                </div>

                <!-- Wykładowcy -->
                <div v-if="hasLecturers" class="lecture__lecturer">
                    <!-- Więcej niż jeden wykładowca -  -->
                    <template v-if="hasMultipleLecturers">
                        <div v-for="lecturer in lecture.lecturers">
                            <span>
                                <template
                                    v-if="typeof lecturer.name === 'string'"
                                >
                                    {{
                                        `${lecturer.name}${
                                            Object.hasOwn(lecturer, "workplace")
                                                ? ","
                                                : ""
                                        }`
                                    }}
                                </template>
                                <template v-else>
                                    {{
                                        `${lecturer.name.value}${
                                            Object.hasOwn(lecturer, "workplace")
                                                ? ","
                                                : ""
                                        }`
                                    }}
                                </template>
                            </span>
                            <span
                                v-if="Object.hasOwn(lecturer, 'workplace')"
                                class="lecture__lecturer-workplace"
                            >
                                {{ `${lecturer.workplace[0].value}` }}
                            </span>
                        </div>
                    </template>

                    <!-- Pojedynczy wykładowca - miejsce pracy w kolejnej linii -->
                    <template v-else>
                        <template
                            v-if="typeof lecture.lecturers[0] === 'string'"
                        >
                            {{ lecture.lecturers[0] }}
                        </template>
                        <template v-else>
                            <div>{{ lecture.lecturers[0].name }}</div>
                            <div
                                v-if="
                                    Object.hasOwn(
                                        lecture.lecturers[0],
                                        'workplace'
                                    )
                                "
                                class="lecture__lecturer-workplace"
                            >
                                {{ lecture.lecturers[0].workplace[0].value }}
                            </div>
                            <div
                                v-if="
                                    Object.hasOwn(
                                        lecture.lecturers[0],
                                        'sponsors'
                                    )
                                "
                            >
                                {{ lecture.lecturers[0].workplace[0].value }}
                            </div>
                        </template>
                    </template>
                </div>
                <!-- Sponsor/zy WYKŁADU -->
                <div v-if="Object.hasOwn(lecture, 'sponsors')">
                    <template v-if="Array.isArray(lecture.sponsors)">
                        <div
                            v-for="sponsor in lecture.sponsors"
                            class="program__title program__title--sponsored-line"
                        >
                            <p
                                class="program__title program__title--sponsored-prefix"
                            >
                                {{ sponsor.prefix }}
                            </p>
                            <img
                                :alt="sponsor.companyName"
                                :class="sponsor.size ? `program__title--${sponsor.size}` : ''"
                                :src="sponsor.imageSrc"
                                class="program__title program__title--sponsored-img"
                            />
                        </div>
                    </template>
                </div>
            </div>
        </td>
        <!-- Obsługa specjalnej linii -->
        <td v-if="Object.hasOwn(lecture, 'customLine')" class="lecture__title">
            <!-- Tablica -->
            <template v-if="Array.isArray(lecture.customLine)">
                <div
                    v-for="customLine in lecture.customLine"
                    :class="`lecture__${customLine.name}`"
                >
                    <span>{{ customLine.value }}</span>
                </div>
            </template>
            <!-- Pojedyncza wartość -->
            <template v-else>
                <div :class="`lecture__${lecture.customLine.name}`">
                    <span>{{ lecture.customLine.value }}</span>
                </div>
            </template>
        </td>
    </tr>
</template>
<script>
export default {
    props: {
        lecture: {
            type: Object,
        },
    },
    computed: {
        hasLecturers() {
            return (
                Object.hasOwn(this.lecture, "lecturers") &&
                Array.isArray(this.lecture.lecturers)
            );
        },
        hasMultipleLecturers() {
            return this.hasLecturers && this.lecture.lecturers.length > 1;
        },
    },
};
</script>
<style lang="scss">
.lecture {
    &__hour {
        font-weight: 500;
        display: flex;
        height: 100%;
        width: 100%;

        &--normal-weight {
            font-weight: 300;
        }
    }

    &__hour-div {
        display: flex;
        flex-direction: column;
    }

    &__title-wrapper,
    &__hour-div {
        padding-block: 5px;
    }

    &__title {
        font-weight: 500;

        .lecture__break {
            font-weight: 300;
            text-transform: uppercase;
        }

        .lecture__discussion {
            font-weight: 300;
        }
    }

    &__lecturer-workplace {
        font-style: italic;
    }
}

div.program__title.program__title--sponsored-line {
    // max-height: 24px;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;
    align-content: flex-start;
    font-size: 0.9375em;
    column-gap: 1rem;
}

p.program__title.program__title--sponsored-prefix {
    margin-block: 0;
    // flex: 0 0 auto;
    vertical-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

img.program__title.program__title--sponsored-img {
    max-height: 1.75em;
}

img.program__title.program__title--sponsored-img.program__title--bigger {
    max-height: 2.5em;
}

img.program__title.program__title--sponsored-img.program__title--big {
    max-height: 2.125em;
}

img.program__title.program__title--sponsored-img.program__title--small {
    max-height: 1.375em;
}

img.program__title.program__title--sponsored-img.program__title--smaller {
    max-height: 1em;
}


</style>
